import { create } from 'zustand'

/**
 * 한도 초과 (429) 모달 글로벌 상태.
 * spec §3.10 — "오늘 한도 다 썼습니다 / 내일 0시 초기화 / 플랜 업그레이드".
 *
 * useChat 등 어느 위치의 API 호출에서든 호출 가능하도록 store로 분리.
 * 모달 자체는 RootLimitsModal 이 __root.tsx 에 마운트되어 listen.
 */

export interface LimitDetail {
  used?: number
  limit?: number
  plan?: 'free' | 'basic' | 'premium'
  kind?: string
}

interface LimitsState {
  exceededModal: { open: boolean; message: string; detail?: LimitDetail }
  showLimitExceeded: (message: string, detail?: LimitDetail) => void
  closeLimitExceeded: () => void
}

export const useLimitsStore = create<LimitsState>((set) => ({
  exceededModal: { open: false, message: '' },
  showLimitExceeded: (message, detail) =>
    set({ exceededModal: { open: true, message, detail } }),
  closeLimitExceeded: () =>
    set((s) => ({ exceededModal: { ...s.exceededModal, open: false } })),
}))
